<template>
  <div style="width: 38px;">
    <div class="year font-medium transform -rotate-90 text-4xl mt-14 -ml-4 -mr-1" :class="{ 'text-muted': !active, 'text-active': active }">{{ year }}</div>
  </div>
</template>

<script>
export default {
  name: "Year",
  props: {
    year: {
      type: Number,
      require: true
    },
    active: Boolean
  }
}
</script>

<style scoped>
.year {
  font-size: 2.2rem;
  line-height: 4.5rem;
  @apply font-bold;
}
</style>
